import { assetsId } from '../services/cms'
import { Collection } from './index'

export const collectionNameToFind = (name: string) =>
  name
    .split('/')
    .filter((el, i) => !(i % 2))
    .join('/')

export const getCollectionProperties = (collections: Collection[], collectionId: string) => {
  const properties =
    collections.find(el => collectionNameToFind(el.name) === collectionNameToFind(collectionId))?.properties || []
  const assetsProperties =
    collections.find(el => collectionNameToFind(el.name) === collectionNameToFind(assetsId))?.properties || []
  return {
    properties,
    assetsProperties,
  }
}
